import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./pages/home/home.page').then((m) => m.HomePage),
  },
  {
    path: 'products/:catalog/:collection/:id/:title',
    loadComponent: () =>
      import('./pages/product/product.page').then((m) => m.ProductPage),
  },
  {
    path: 'products/:catalog/:collection',
    loadComponent: () =>
      import('./pages/search/search.page').then((m) => m.SearchPage),
  },
  {
    path: 'search',
    loadComponent: () =>
      import('./pages/simple-search/simple-search.page').then(
        (m) => m.SimpleSearchPage,
      ),
  },
  {
    path: 'products/:catalog',
    loadComponent: () =>
      import('./pages/search/search.page').then((m) => m.SearchPage),
  },
  {
    path: 'products',
    loadComponent: () =>
      import('./pages/products/products.page').then((m) => m.ProductsPage),
  },
  {
    path: 'about',
    loadComponent: () =>
      import('./pages/about/about.page').then((m) => m.AboutPage),
  },
  {
    path: 'contact',
    loadComponent: () =>
      import('./pages/contact/contact.page').then((m) => m.ContactPage),
  },
  {
    path: 'return-policy',
    loadComponent: () =>
      import('./pages/return-policy/return-policy.page').then(
        (m) => m.ReturnPolicyPage,
      ),
  },
  {
    path: 'warranty-and-return-policy',
    redirectTo: 'return-policy',
    pathMatch: 'full',
  },
  {
    path: 'terms-and-conditions',
    loadComponent: () =>
      import('./pages/terms-and-conditions/terms-and-conditions.page').then(
        (m) => m.TermsAndConditionsPage,
      ),
  },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./pages/dashboard/dashboard.page').then((m) => m.DashboardPage),
  },
  {
    path: 'basket/:id',
    loadComponent: () =>
      import('./pages/cart/cart.page').then((m) => m.CartPage),
  },
  {
    path: 'checkout/:id',
    loadComponent: () =>
      import('./pages/checkout/checkout.page').then((m) => m.CheckoutPage),
  },
];
